<template>
  <g fill-rule="evenodd">
    <path
      d="M3.7 14.62a.7.7 0 000 1.4h11.86a.7.7 0 00.7-.7.7.7 0 00-.71-.7H3.7zM10.98 3a.73.73 0 00-.5.2L9.01 4.67l-5.8 5.78-.02.02c-.1.12-.19.28-.19.48L3 13.05c0 .19.07.37.2.51.14.13.32.2.5.2h2.1a.7.7 0 00.49-.2l7.25-7.26a.72.72 0 000-1l-2.08-2.1a.7.7 0 00-.5-.2z"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EditIcon",
});
</script>
